// require("./assets/js/lang.js");
// require("./assets/js/ball.js");
// require("./assets/js/init.js");

// require("./assets/js/b_canvas.js");
import BColor from './b_utils/b_color.js';
import BAjax from './b_utils/b_ajax.js';
import BApp from './b_utils/b_app.js';

require("./handle_safe.js");
require("./focus_win.js");

$(function () {
  let anis = [
    "animate__rollIn",
    // "animate__rollIn",
    // "animate__fadeInDownBig",
    // "animate__bounceInLeft"
  ]

  let texts = [
    "音画联动",
    "智能卡点",
    "智能配色",
    "多种音源支持",
    "歌词显示支持",
    "50+ 视觉效果<br>不断增加中",
    "配合 RAV Controller<br>可对视觉效果进行实时控制"
  ]

  const windowResizeHanlder = () => {
    $("#intro-row").css("width", window.innerWidth)
  }
  windowResizeHanlder()
  window.addEventListener('resize', windowResizeHanlder);

  let i = 0
  function showAniText () { 
    let color = BColor.getRainbowColorFormatRGB(parseInt(i % BColor.getRainbowColorsLength()))
    let ani = anis[parseInt(i % anis.length)]
    let txt = texts[i]
    $('#intro-row').html(`<div id="intro-row-txt" class="text-shadow animate__animated ${ani}" style="color: ${color}"><span>${txt}</span></div>`)
    let rs = txt.indexOf("<br>") > 0 ? 1 : 0
    let txtLen = txt.length - rs*4

    setTimeout(()=>{
      $('#intro-row-txt').removeClass("animate__rollIn")
      $('#intro-row-txt').addClass("animate__rollOut")
      setTimeout(showAniText, 1000)
    }, 2000 + txtLen*100)

    i += 1
    if (i == texts.length) {
      i = 0
    }
  }
  showAniText()

  if (BApp.isProduct()) {
    // 统计访问量
    BAjax.post({
      url: 'visit/',
      url_root: "/stats/",
      data: {
        url: window.location.href
      },
      success: (data) => {
      }
    });
  }

  // 设置 RAV Player 颜色
  $("#rav-player-title").html(`
  <span style="color: ` + BColor.getRainbowColorFormatRGB(0) + `;">R</span><span style="color: ` + BColor.getRainbowColorFormatRGB(3) + `;">A</span><span
    style="color: ` + BColor.getRainbowColorFormatRGB(5) + `;">V</span>&nbsp;<span style="color: ` + BColor.getRainbowColorFormatRGB(6) + `;">Player</span>
  `)
})